import { useMemo } from "react";
import { useOptionalFilters } from "components/Elements/Filters/FilterContext";
import { formatFilterSummary } from "helpers/reportSubscriptions";

// Returns the current page's filter selections as a simple [{ label, value }]
// list, suitable for read-only display in the subscribe modal. Resilient when
// no FilterProvider is mounted (returns []).
export const useFilterSummary = () => {
	const ctx = useOptionalFilters();
	const filterValues = ctx?.filterValues || {};
	return useMemo(() => formatFilterSummary(filterValues), [filterValues]);
};
